import { render, staticRenderFns } from "./KSelectList.vue?vue&type=template&id=a28a0dd2&scoped=true&"
import script from "./KSelectList.vue?vue&type=script&lang=js&"
export * from "./KSelectList.vue?vue&type=script&lang=js&"
import style0 from "./KSelectList.vue?vue&type=style&index=0&id=a28a0dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a0dd2",
  null
  
)

export default component.exports